
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import { Form } from "react-router-dom";
import axios from "../../API/axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import { debounce } from "lodash";
import {customStyles, wljSelectPortalProps} from "../../selectStyles";
import { findSelectOption, resolveOrgUid, seedSelectOptions } from "../../utility/selectFieldHelpers";
import Flatpickr from 'react-flatpickr';
import { resume } from "../../config/imagesLink";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Button, Overlay, Popover } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";


const CCVAwardUpdate = ({
    showAwardUpdate,
    handleUpdateAwardClose,
    showAwardData,
    getUserCcv,
    resumeId
}) => {
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const UserCcv = localStorage.getItem("UserCcv");
    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);
    const { t } = useTranslation();
    const language = localStorage.getItem("Lang");
    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);
    console.log('showAwardData', showAwardData);
    const sessionId = localStorage.getItem("sessionId");
    const [cerName, setCerName] = useState('');
    const [recognition, setRecognition] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [description, setDescription] = useState("");
    const [orgType, setOrgType] = useState("");

    const [cityData, setCityData] = useState([]);
    const [cityId, setCityId] = useState(null);
    const [citySearch, setCitySearch] = useState("");

    const [display, setDisplay] = useState(false);

    const getCity = () => {
        axios
            .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
            .then((response) => {
                const res = response.data.responseData;
                const data = res.map((item) => ({
                    value: item.cityId,
                    label: item.cityName,
                }));
                setCityData(data);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    useEffect(() => {
        if (citySearch) {
            getCity();
        }
    }, [citySearch]);

    const [orgData, setOrgData] = useState([]);
    const [orgId, setOrgId] = useState(null);
    const getOrgType = () => {
        axios
            .get(`Master/GetOrgTypesDDL?LangKey=${language}`)
            .then((response) => {
                const res = response.data.responseData;
                const data = res.map((item) => ({ value: item.id, label: item.name }));
                setOrgData(data);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    useEffect(() => {
        getOrgType();
    }, []);

      const [sync, setSync] = useState(false);


    const [valueC, setValueC] = useState(null);
    const [pageC, setPageC] = useState(0);
    const [typeC, setTypeC] = useState("");
    const [isLoadingC, setIsLoadingC] = useState(false);
    const [optionsC, setOptionsC] = useState([]);
    const [totalPagesCom, setTotalPagesCom] = useState(0);

    const logValueC = debounce((typeC) => {
        setTypeC(typeC);
    }, 250);

    const Companies = () => {
        setIsLoadingC(true);
        axios
            .get(
                `Master/GetCompaniesDDL?search=${typeC}&pageNumber=${pageC + 1
                }&pageSize=100&LangKey=${language}&DeviceType=Web`
            )
            .then((response) => {
                console.log(response);
                const data = response?.data?.responseData?.orgList.map((item) => ({
                    value: item.uiDno,
                    label: item.name,
                }));
                setPageC((prevPage) => prevPage + 1);
                setIsLoadingC(false);
                setOptionsC((prevOptions) => [...prevOptions, ...data]);
                setTotalPagesCom(response.data.paging.totalPages);
            })
            .catch((error) => {
                console.log(error);
                setIsLoadingC(false);
            });
    };

    const handleOpenC = () => {
        setPageC(1);
    };

    const handleChangeC = (value) => {
        setValueC(value.value);
        setPageC(0);
    };

    const handleInputChangeC = (typed) => {
        logValueC(typed);
        if (!typed) setPageC(0);
    };

    const handleMenuScrollToBottomC = () => {
        if (pageC < totalPagesCom) {
            Companies();
        }
    };
    useEffect(() => {
        if (typeC) {
            Companies();
        }
    }, [typeC]);
    //********Institution DDL Start  ********//
    const [valueIns, setValueIns] = useState(null);
    const [pageIns, setPageIns] = useState(0);
    const [typedIns, setTypedIns] = useState("");
    const [optionsIns, setOptionsIns] = useState([]);
    const [totalPagesIns, setTotalPagesIns] = useState(0);
    const logValueIns = debounce((typedIns) => {
        setTypedIns(typedIns);
    }, 250);
    // console.log('typed', typed);
    const addOptionsIns = () => {
        axios
            .get(
                `Master/GetInstitutionsDDL?search=${typedIns}&pageNumber=${pageIns + 1
                }&pageSize=100&LangKey=${language}`
            )
            .then((response) => {
                console.log(response.data.responseData.orgList);
                const data = response.data.responseData.orgList.map((item) => ({
                    value: item.uiDno,
                    label: item.name,
                }));
                setPageIns((prevPage) => prevPage + 1);
                setOptionsIns((prevOptions) => [...prevOptions, ...data]);
                setTotalPagesIns(response.data.responseData.paging.totalPages);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleOpenIns = () => {
        setPageIns(1);
    };

    const handleChangeIns = (valueIns) => {
        if (valueIns) {
            setValueIns(valueIns.value);
        } else {
            setValueIns(""); // or handle the clear case appropriately
        }

        setPageIns(0);
    };

    const handleInputChangeIns = (typedIns) => {
        logValueIns(typedIns);
        if (!typedIns) setPageIns(0);
    };

    const handleMenuScrollToBottomIns = () => {
        if (pageIns < totalPagesIns) {
            addOptionsIns();
        }
    };

    useEffect(() => {
        if (typedIns) {
            addOptionsIns();
        }
    }, [typedIns]);

    //********General Org DDL Start  ********//
    const [valuegnr, setValuegnr] = useState(null);
    const [pagegnr, setPagegnr] = useState(0);
    const [typedgnr, setTypedgnr] = useState("");
    const [optionsgnr, setOptionsgnr] = useState([]);
    const [totalPagesgnr, setTotalPagesgnr] = useState(0);
    const logValuegnr = debounce((typedgnr) => {
        setTypedgnr(typedgnr);
    }, 250);
    console.log("typed", valuegnr);
    const addOptionsgnr = () => {
        axios
            .get(
                `Master/GetAllOrganizationsDDL?search=${typedgnr}&pageNumber=${pagegnr + 1
                }&pageSize=100&DeviceType=Web&LangKey=${language}`
            )
            .then((response) => {
                console.log(response.data.responseData.orgList);
                const data = response.data.responseData.list.map((item) => ({
                    value: item.uiDno,
                    label: item.name,
                    typeId: item.typeId,
                    isOrgVrfd: item.isVerified,
                    isOrgRgd: item.isRgstrd,
                }));
                setPagegnr((prevPage) => prevPage + 1);
                setOptionsgnr((prevOptions) => [...prevOptions, ...data]);
                setTotalPagesgnr(response.data.responseData.paging.totalPages);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleOpengnr = () => {
        setPagegnr(1);
    };

    const handleChangegnr = (valuegnr) => {
        if (valuegnr) {
            setValuegnr(valuegnr.value);
            setOrgType(valuegnr.typeId)
        } else {
            setValuegnr(""); // or handle the clear case appropriately
            setOrgType("")
        }

        setPagegnr(0);
    };

    const handleInputChangegnr = (typedgnr) => {
        logValuegnr(typedgnr);
        if (!typedgnr) setPagegnr(0);
    };

    const handleMenuScrollToBottomgnr = () => {
        if (pagegnr < totalPagesgnr) {
            addOptionsgnr();
        }
    };
    useEffect(() => {
        if (typedgnr) {
            addOptionsgnr();
        }
    }, [typedgnr]);
    const [getOrgInsTId, setGenOrgInstId] = useState('')
    const [newOrgType, setnewOrgType] = useState(null);
    const UpdateAward = async () => {
        setDisplay(true);
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            rsmId: resumeId,
            name: cerName,
            recognition: recognition,
            issuingOrgType: orgType === '' ? 4 : orgType,
            orgId: valuegnr === null ? JSON.stringify(getOrgInsTId) : valuegnr,
            description: description,
            issueDate: startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD"),
            // "locationId": valueLocation === '' ? '' : valueLocation,
            locationId: null,
            cityId: cityId === "" ? "" : cityId,
            rsmAwardId: showAwardData?.rsmAwrdId,
        };
        const data1 = {
            deviceType: "Web",
            sessionId: sessionId,
            name: cerName,
            recognition: recognition,
            issuingOrgType: orgType === '' ? 4 : orgType,
            orgId: valuegnr === null ? JSON.stringify(getOrgInsTId) : valuegnr,
            description: description,
            issueDate: startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD"),
            // "locationId": valueLocation === '' ? '' : valueLocation,
            locationId: null,
            cityId: cityId === "" ? "" : cityId,
            userAwardId: showAwardData?.userAwardId,
            langKey: language === "en" ? "" : language,
            isSynced: sync
        };
        const apiUrl = showAwardData.isSyncedWithUserData
            ? `UserData/UpdateAwardInfo`
            : `ResumeData/UpdateAwardInfo`;

        const payload = showAwardData.isSyncedWithUserData ? data1 : data;
        try {
            await axios.put(apiUrl, payload).then((resData) => {
                console.log("resData award", resData);
                // toast.success(resData.data.message);
                setToastMessage(resData.data.message);
                setShowToast(true);
                getUserCcv();
                handleUpdateAwardClose();
                // addReset()
            });
        } catch (error) {
            console.log(error);
            // toast.error(error.response.data.message);
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.title);
                setShowErrorToast(true);
            }
        }
    };


    // useEffect(() => {
    //     if (showAwardUpdate) {
    //         document.body.style.overflow = 'hidden';
    //         document.documentElement.style.overflow = 'hidden';
    //         document.body.classList.add('modal-open'); // When a modal opens
    //     } else {
    //         document.body.style.overflow = 'unset';
    //         document.documentElement.style.overflow = '';
    //         document.body.classList.remove('modal-open'); // When a modal closes
    //     }
    // }, [showAwardUpdate]);


    useEffect(() => {
        if (showAwardData) {
            const orgValue =
                showAwardData?.orgUid ?? showAwardData?.orgUId ?? showAwardData?.orgId;
            setCerName(showAwardData?.name);
            setRecognition(showAwardData?.recognition);
            setStartDate(showAwardData.issueDate ? moment(showAwardData.issueDate).toDate() : null);
            setDescription(showAwardData?.description);
            setOrgId(showAwardData?.issuerOrgType);
            setOrgType(showAwardData?.issuerOrgType);
            setCityId(showAwardData?.cityId);
            setCitySearch(showAwardData?.cityName)
            setTypeC(showAwardData?.orgId)
            setValueC(showAwardData?.orgId)
            setValuegnr(orgValue)
            setTypedgnr(showAwardData?.orgName)
            setPagegnr(0)
            if (showAwardData?.orgName && orgValue) {
                setOptionsgnr(seedSelectOptions(orgValue, showAwardData.orgName, {
                    typeId: showAwardData.issuerOrgType,
                    isOrgVrfd: showAwardData.isOrgVrfd,
                    isOrgRgd: showAwardData.isOrgRgd,
                }));
            }
            if (showAwardData?.cityId && showAwardData?.cityName) {
                setCityData(seedSelectOptions(showAwardData.cityId, showAwardData.cityName));
            }
        }
    }, [showAwardData]);
    // console.log('showAwardData', cityId);

    const preventYearScroll = (datePickerInstance) => {
        const yearElement = datePickerInstance.currentYearElement;
        if (yearElement) {
            yearElement.addEventListener("wheel", (e) => {
                e.preventDefault(); // Stops mouse scroll
            });
        }
    };

    const [showTooltip, setShowTooltip] = useState(false);
    const [OrganizationName, setOrganizationName] = useState("");
    const [InsName, setInsName] = useState("");
    const targetRef = useRef(null);
    const toggleTooltip = () => {
        console.log("Toggling Tooltip");
        setShowTooltip((prev) => !prev);
    };

    const handleCloseNewOrg = (e) => {
        e?.preventDefault?.();
        setInsName("");
        setOrganizationName("");
        setGenOrgInstId("");
        setnewOrgType(null);
        setValuegnr(null);
        setOrgType("");
        setFileName("");
    };

    const [fileName, setFileName] = useState(""); // State to store selected filename
    const handleFileChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            setFileName(file.name); // Set the filename in state
        }
    };



    const [orgCity, setOrgCity] = useState(null);
    const handleSaveInstitution = async () => {
        // setDisplay(true);

        // const formData = new FormData();
        // formData.append("orgName", OrganizationName);
        // formData.append("OrgType", "UnRegdInstitution");
        // formData.append("CityID", orgCity);
        // formData.append("OrgLogo", fileName);
        // formData.append("sessionId", sessionId);
        // console.log("formData", formData);

        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            gnrlOrgName: OrganizationName,
            type: 3,
            cityId: cityId,
            logoImage: fileName,
            locationId: null,
            langKey: language === "en" ? "" : language,
        }

        try {
            const res = await axios.post("/General/AddGeneralOrgByUser", data);
            console.log("resposne new", res);
            setGenOrgInstId(res.data.responseData.id);
            setnewOrgType(res.data.responseData.value);
            setInsName(res.data.responseData.value);
            // toast.success(res.data.message);
            setShowTooltip(false);
            setOrganizationName("");
            setOrgCity(null);
            setFileName("");
        } catch (error) {
            if (error.response && error.response.status === 404) {
                // toast.warning(error.response.data.message);
            } else {
                // toast.error(error.response?.data?.message || "An error occurred");
            }
        }
    };

//   useEffect(() => {
//   let scrollY = 0;

//   if (showAwardUpdate) {
//     scrollY = window.scrollY;

//     // Lock scroll
//     document.body.style.position = 'fixed';
//     document.body.style.top = `-${scrollY}px`;
//     document.body.style.left = '0';
//     document.body.style.right = '0';
//     document.body.style.overflow = 'hidden';
//     document.documentElement.style.overflow = 'hidden'; // 🛠️ Add this line
//     document.body.classList.add('modal-open');
//   } else {
//     // Unlock scroll
//     const scrollYValue = document.body.style.top;
//     document.body.style.position = '';
//     document.body.style.top = '';
//     document.body.style.left = '';
//     document.body.style.right = '';
//     document.body.style.overflow = '';
//     document.documentElement.style.overflow = ''; // 🛠️ Add this line
//     document.body.classList.remove('modal-open');

//     window.scrollTo(0, parseInt(scrollYValue || '0') * -1);
//   }
// }, [showAwardUpdate]);

useEffect(() => {
  let scrollY = 0;

  if (showAwardUpdate) {
    // Save current scroll position
    scrollY = window.scrollY;
    document.body.dataset.scrollY = scrollY; // store in dataset

    // Lock scrolling
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('modal-open');
  } else {
    // Unlock scrolling
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.classList.remove('modal-open');

    // Restore scroll position
    const storedY = document.body.dataset.scrollY || "0";
    window.scrollTo(0, parseInt(storedY, 10));
  }
}, [showAwardUpdate]);

const modalContentRef = useRef(null);
    return (
        <>
            {showAwardUpdate && (
                <Portal layer="modal">
                <div
                    className="modal fade show modal-lg wlj-overlay-modal"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "flex" }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" ref={modalContentRef}>
                            {/* <div className="modal-content"> */}
                            <div className="setting-header d-flex justify-content-between align-items-center">
                                <h6>{t("User Profile.Update Award")}</h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-3 pointer"
                                    onClick={() => {
                                        handleUpdateAwardClose();
                                        // addReset()
                                    }}
                                />
                            </div>
                            <Form>
                                <div className="row modal-p settings CreateCompany">
                                    <div className="col-md-6 mt-2 ">
                                        <label htmlFor="about">
                                            {t("User Profile.Award Name")}<span className="text-danger ms-2">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            value={cerName}
                                            onChange={(e) => setCerName(e.target.value)}
                                            invalid={display && cerName === ""}
                                        />
                                        {display && !cerName ? (
                                            <span className="error_msg_lbl">{t("User Profile.Enter Award Name")} </span>
                                        ) : null}
                                    </div>


                                    <div className="col-md-6 mt-2">
                                        <div className="wlj-edu-label-row d-flex align-items-center">
                                        <label htmlFor="about" className="mb-0">
                                            {t("User Profile.Organization")}
                                            <span className="text-danger ms-2">*</span>
                                        </label>
                                        {InsName !== "" ? (
                                            <a
                                                href="#"
                                                onClick={handleCloseNewOrg}
                                                className="createModal f-14 ms-2"
                                            >
                                                {t("User Profile.Close")}
                                            </a>
                                        ) : (
                                        <a
                                            href="#"
                                            ref={targetRef}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleTooltip();
                                            }}
                                            className="createModal f-14 ms-2"
                                        >
                                           {t("User Profile.Create New")}
                                        </a>
                                        )}
                                        </div>
                                        <Overlay
                                            target={targetRef.current}
                                            show={showTooltip}
                                            placement="bottom"
                                            rootClose
                                            container={document.querySelector(".modal")}
                                            onHide={() => setShowTooltip(false)} // Close when clicking outside
                                        >
                                            <Popover id="popover-basic">
                                                <Popover.Header as="h3" className="Dark-Body-Card-group">{t("modals.Create Organization")}</Popover.Header>
                                                <Popover.Body className="Dark-Body-Card-group">
                                                    <Form>
                                                        <div>
                                                            <label className="mb-1 Text-mb-Create">{t("User Profile.Organization Name")}</label>
                                                            <input
                                                                type="text"
                                                                value={OrganizationName}
                                                                onChange={(e) => setOrganizationName(e.target.value)}
                                                                placeholder={t("User Profile.Enter Org name")}
                                                                className="mb-2 form-control Dark-Input-from-group"
                                                            />
                                                        </div>
                                                        <div>
                                                            <label className="mb-1 Text-mb-Create">{t("User Profile.City")}</label>
                                                            <Select
                                                                defaultValue={cityId}
                                                                onChange={(selectedOption) =>
                                                                    setCityId(selectedOption.value)
                                                                }
                                                                options={cityData}
                                                                placeholder={t("modals.Search and Select City")}
                                                                onInputChange={(inputValue) => {
                                                                    setCitySearch(inputValue);

                                                                }}
                                                                invalid={display && cityId === ""}
                                                                styles={customStyles} {...wljSelectPortalProps}
                                                            />
                                                        </div>
                                                        <div className=" mt-2 mb-2 Text-mb-Create">
                                                            <label className="mb-1">{t("User Profile.Institute logo")}</label>
                                                            <input
                                                                type="file"
                                                                id="lastName"
                                                                // className="form-control Dark-Input-from-group"
                                                                placeholder=""
                                                                onChange={handleFileChange}
                                                            //   onChange={(e) => {
                                                            //     handleProfileImageChange(e);
                                                            //   }}
                                                            //   invalid={displays && profileImage === ""}
                                                            />
                                                            {/* {displays && !profileImage ? (
                          <span className="error_msg_lbl text-red">
                            Upload Image{" "}
                          </span>
                        ) : null} */}
                                                        </div>
                                                        <div className="d-flex justify-content-end">
                                                            <Button
                                                                variant="primary"
                                                                size="sm"
                                                                onClick={handleSaveInstitution}
                                                                className="me-2"
                                                            >
                                                                {t("Newsfeed.Save")}
                                                            </Button>
                                                            <Button
                                                                variant="secondary"
                                                                size="sm"
                                                                onClick={() => {
                                                                    setShowTooltip(false);
                                                                    setOrganizationName("");
                                                                }}
                                                            >
                                                                {t("Connections.Cancel")}
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </Popover.Body>
                                            </Popover>
                                        </Overlay>
                                        {InsName !== "" ? (
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="text"
                                                    value={InsName}
                                                    placeholder={t("User Profile.Enter Org name")}
                                                    className="mb-2 form-control"
                                                    disabled
                                                />
                                                <CloseSharpIcon
                                                    className="material-symbols-sharp pointer ms-2 mb-2"
                                                    onClick={handleCloseNewOrg}
                                                    title={t("User Profile.Close")}
                                                />
                                            </div>
                                        ) : (
                                        <Select
                                            value={findSelectOption(optionsgnr, valuegnr)}
                                            options={optionsgnr}
                                            onOpen={handleOpengnr}
                                            onChange={handleChangegnr}
                                            onMenuScrollToBottom={handleMenuScrollToBottomgnr}
                                            onInputChange={handleInputChangegnr}
                                            styles={customStyles} {...wljSelectPortalProps}
                                            isClearable
                                            className="iconsDropdown"
                                            classNamePrefix="react-select"
                                            placeholder={t("User Profile.Search and Select Org")}
                                            formatOptionLabel={(option) => (
                                                <div>
                                                    {option.label}
                                                    {option.isOrgVrfd === true ? (
                                                        <img src={resume.verified} width={15} className="ms-1" />
                                                    ) : option.isOrgRgd === true ? (
                                                        <img src={resume.register} width={15} className="ms-1" />
                                                    ) : (
                                                        <img src={resume.unregister} width={15} className="ms-1" />
                                                    )}
                                                </div>
                                            )}
                                        />
                                        )}
                                        {display && !valuegnr && !getOrgInsTId ? (
                                            <span className="error_msg_lbl">
                                                {t("User Profile.Please Select Organization Type")}{" "}
                                            </span>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="about">
                                            {t("User Profile.Recognition")}
                                        </label>
                                        <input
                                            type="text"
                                            value={recognition}
                                            onChange={(e) => setRecognition(e.target.value)}
                                        // invalid={display && recognition === ""}
                                        />
                                        {/* {display && !recognition ? (
                      <span className="error_msg_lbl">Enter Recognition </span>
                    ) : null} */}
                                    </div>

                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="about">
                                            {t("User Profile.City")}<span className="text-danger ms-2">*</span>
                                        </label>
                                        <Select
                                            value={findSelectOption(cityData, cityId)}
                                            className="dropdownBorder"
                                            onChange={(selectedOption) =>
                                                setCityId(selectedOption.value)
                                            }
                                            options={cityData}
                                            placeholder={t("modals.Search and Select City")}
                                            onInputChange={(inputValue) => {
                                                setCitySearch(inputValue);
                                            }}
                                            styles={customStyles} {...wljSelectPortalProps}
                                            classNamePrefix="react-select"
                                            invalid={display && cityId === ""}
                                        />
                                        {display && !cityId ? (
                                            <span className="error_msg_lbl">{t("User Profile.Enter City")}</span>
                                        ) : null}
                                    </div>


                                    <div className="col-md-6 mt-2">
                                        <label htmlFor="about">
                                            {t("User Profile.Issue Date")}<span className="text-danger ms-2">*</span>
                                        </label>

                                        <Flatpickr className='form-control' value={startDate}
                                            onChange={date => setStartDate(date[0])} id='dob'
                                            options={{
                                                maxDate: "today", // Disables future dates
                                                appendTo: modalContentRef.current || undefined, // Appends the calendar to the modal content
                                                onReady: (selectedDates, dateStr, instance) => {
                                                    preventYearScroll(instance); // Call the function to stop scroll on year
                                                },
                                                onOpen: (selectedDates, dateStr, instance) => {
                                                    preventYearScroll(instance); // Also prevent scroll when the picker opens
                                                },
                                            }} />
                                        {display && !startDate ? (
                                            <span className="error_msg_lbl">
                                                {t("User Profile.Please Select Issue Date")}{" "}
                                            </span>
                                        ) : null}

                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <label htmlFor="about">
                                            {t("User Profile.Description")}
                                        </label>
                                        <textarea
                                            id="about"
                                            name="about"
                                            rows="4"
                                            cols="50"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                        // invalid={display && description === ""}
                                        ></textarea>
                                        {/* {display && !description ? (
                      <span className="error_msg_lbl">Enter Description </span>
                    ) : null} */}
                                    </div>

                                    <div className="text-end mt-4">
                                         <div className="d-flex align-items-center justify-content-end">
                                           
                                           {UserCcv === "Active" && <>
                                             <input
                                                type="checkbox"
                                                style={{ width: "20px", height: "20px", marginRight: "5px" }}
                                                onChange={() => setSync(!sync)}
                                                checked={sync}
                                            />
                                            <label htmlFor="about">
                                                {t("User Profile.Sync With Profile")}
                                            </label>
                                            </>}
                                        <button
                                            type="button"
                                            className="closebtn me-2 ms-3"
                                            onClick={handleUpdateAwardClose}
                                            style={{ width: "70px" }}
                                        >
                                            {t("User Profile.Close")}
                                        </button>
                                        <button
                                            type="button"
                                            className="mainBtn1"
                                            onClick={UpdateAward}
                                            style={{ width: "107px" }}
                                        >
                                            {t("Manage Job.Update")}
                                        </button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
                </Portal>
            )}

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    );
};

export default CCVAwardUpdate;
